<template>
  <div id="bankDepository-view">
    <p class="mine-title">银行存管</p>
    <div class="paper-box" v-if="!userInfo.realNameInfo.id">
      <div class="paper-text-box">
        <p class="title">依存管银行要求，即日起新注册用户实名认证需提交以下纸质资料</p>
        <p class="text">1、实名认证者身份证正反面影像件</p>
        <p class="text">2、开通个人存管账号申请书</p>
      </div>
      <div class="paper-boxC"></div>
      <div class="paper-btn-box">
        <div class="btn red" @click="windowOpen('exampleFlag', true)">查看示例</div>
        <div class="btn" @click="loadBook">下载申请书</div>
      </div>
    </div>
    <ul class="bankDepository-section">
      <li v-show="custType4">
        <span class="label"
          v-bind:class="{'label-accomplish': userInfo.companyName}">{{ userInfo.companyName ? '已设置' : '未设置' }}</span>
        <img
          :src="require(userInfo.realNameInfo.id ? '../../assets/images/bankDepository-1-hover.png' : '../../assets/images/bankDepository-1.png')" />
        <p class="type">企业信息</p>
        <span class="detail" v-show="userInfo.companyName">{{ userInfo.companyName}}</span>
        <div class="cursor-pointer" v-on:click="modifyinformation">{{ userInfo.companyName ? '修改信息' : '立即设置' }}</div>
      </li>
      <li>
        <span class="label"
          v-bind:class="{'label-accomplish': userInfo.realNameInfo.id}">{{ userInfo.realNameInfo.id ? '已实名' : '未实名' }}</span>
        <img
          :src="require(userInfo.realNameInfo.id ? '../../assets/images/bankDepository-1-hover.png' : '../../assets/images/bankDepository-1.png')" />
        <p class="type">实名认证</p>
        <span class="detail" v-show="gorealNameClassFlag">{{ gorealNameTip }}</span>
        <span class="detail display-block" v-show="gorealNameClassFlag">{{ userInfo.realNameInfo.idCard }}</span>
        <div class="cursor-pointer"
          v-bind:class="{'accomplish': gorealNameClassFlag, 'cursor-pointer': gorealNameClassFlag}"
          v-on:click="realNameenterOrpeo">{{gorealName}}</div>
      </li>
      <li v-show="custType3">
        <span class="label"
          v-bind:class="{'label-accomplish': userInfo.custUserInfo.riskLevel && riskLevelCode}">{{ userInfo.custUserInfo.riskLevel && riskLevelCode ? '已测评' : '未测评' }}</span>
        <img
          :src="require(userInfo.custUserInfo.riskLevel && riskLevelCode ? '../../assets/images/bankDepository-2-hover.png' : '../../assets/images/bankDepository-2.png')" />
        <p class="type">风险测试</p>
        <span
          class="detail">{{ userInfo.custUserInfo.riskLevel && riskLevelCode ? userInfo.custUserInfo.riskLevel : '保守型' }}</span>
        <div class="cursor-pointer" v-on:click="windowOpen('riskLevelWindowFlag', true)">
          {{ userInfo.custUserInfo.riskLevel && riskLevelCode ? '重新测评' : '立即测评' }}</div>
      </li>
      <li>
        <span class="label"
          v-bind:class="{'label-accomplish': userInfo.bankInfo.id}">{{ userInfo.bankInfo.id ? '已绑定' : '未绑定'}}</span>
        <img
          :src="require(userInfo.bankInfo.id ? '../../assets/images/bankDepository-3-hover.png' : '../../assets/images/bankDepository-3.png')" />
        <p class="type">绑定银行卡</p>
        <span class="detail" v-show="userInfo.bankInfo.id "
          v-html="userInfo.bankInfo.bankName + '<br>' +  userInfo.bankInfo.bankNo"></span>
        <div class="cursor-pointer" v-on:click="bindBank()">{{ userInfo.bankInfo.id ? '解绑银行卡' : '绑定银行卡'}}</div>
      </li>
      <li v-show="custType3">
        <span class="label"
          v-bind:class="{'label-accomplish': userInfo.custUserInfo.mobile}">{{ userInfo.custUserInfo.mobile ? '已设置' : '未设置'}}</span>
        <img
          :src="require(userInfo.custUserInfo.mobile ? '../../assets/images/bankDepository-4-hover.png' : '../../assets/images/bankDepository-4.png')" />
        <p class="type">交易手机号</p>
        <span class="detail" v-show="userInfo.bankInfo.id">{{ userInfo.bankInfo.yeepayMobile }}</span>
        <div class="cursor-pointer" v-on:click="resetPhone()">{{ userInfo.custUserInfo.mobile ? '重新设置' : '立即设置'}}</div>
      </li>
      <li>
        <span class="label"
          v-bind:class="{'label-accomplish': userInfo.bankInfo.id}">{{ userInfo.bankInfo.id ? '已设置' : '未设置'}}</span>
        <img
          :src="require(userInfo.bankInfo.id ? '../../assets/images/bankDepository-5-hover.png' : '../../assets/images/bankDepository-5.png')" />
        <p class="type">交易密码</p>
        <span class="detail" v-show="userInfo.bankInfo.id" v-html="'在账户资金变动时</br>需要输入的密码'"></span>
        <div class="cursor-pointer" v-on:click="resetPassword()">{{ userInfo.bankInfo.id ? '重新设置' : '立即设置'}}</div>
      </li>
      <li v-show="custType3">
        <img
          :src="require(userInfo.realNameInfo.id ? '../../assets/images/bankDepository-6-hover.png' : '../../assets/images/bankDepository-6.png')" />
        <p class="type">出借服务协议</p>
        <div v-on:click="openFile(4)" class="cursor-pointer">查看</div>
      </li>
      <li v-show="custType3">
        <img
          :src="require(userInfo.realNameInfo.id ? '../../assets/images/bankDepository-7-hover.png' : '../../assets/images/bankDepository-7.png')" />
        <p class="type">风险提示</p>
        <div v-on:click="openFile(2)" class="cursor-pointer">查看</div>
      </li>
    </ul>
    <!-- 资料示例 -->
    <div id="example-model" class="model" v-show="exampleFlag">
      <i class="iconfont icon-close model-close-button" v-on:click="windowClose('exampleFlag')"></i>
      <p class="example-title">资料示例</p>
      <div class="example-content">
        <div class="content-box">
          <p class="title">1、实名认证者身份证正反面影像件</p>
          <p class="text">请将身份证正反面复印至同一面A4纸</p>
          <img src="../../assets/images/example.png" alt="" style="width: 108px;height: 156px; margin-left: 18px;" />
        </div>
        <div class="content-box">
          <p class="title">2、开通个人存管账号申请书</p>
          <p class="text" style="width: 142px;">用A4纸打印申请书并填写内容（签名并按手印），手持申请书拍照后打印（照片需看清申请书内容）</p>
          <img src="../../assets/images/example-people.png" alt=""
            style="width: 103px;height: 122px;margin-left: 18px;" />
          <div class="btn" @click="loadBook">下载申请书</div>
        </div>
        <div class="content-box">
          <p class="title">3、收件人信息</p>
          <p class="text" style="width: 142px;">
            普惠理财/13366401831
            <br />
            北京市石景山区苹果园路28号院前海人寿大厦B座13层
            <br />
            <br />
            注：邮费需邮寄方自付，请勿到付。
          </p>
          <div class="btn bottom" v-clipboard:copy="inviteUrl" v-clipboard:success="onCopy" v-clipboard:error="onError">
            复制</div>
        </div>
      </div>
    </div>
    <!-- 实名认证model -->
    <div id="realName-model" class="model" v-show="realNameWindowFlag">
      <i class="iconfont icon-close model-close-button" v-on:click="windowClose('realNameWindowFlag')"></i>
      <p class="realName-model-title">实名认证</p>
      <el-form :model="realName_form" status-icon :rules="realName_rules" ref="realName_form">
        <el-form-item label="" prop="name">
          <el-input v-model.trim="realName_form.name" v-on:input="changeCode('realName_form.name')"
            placeholder="请输入真实姓名" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="" prop="id">
          <el-input v-model.trim="realName_form.id" v-on:input="changeCode('realName_form.id')" placeholder="请输入身份证号"
            auto-complete="off"></el-input>
        </el-form-item>
        <div class="register-button button-hover" @click="submit('realName_form')">确认</div>
      </el-form>
    </div>
    <!--企业实名认证-->
    <div id="realName-model" class="model" v-show="realNameWindowFlag2">
      <i class="iconfont icon-close model-close-button" v-on:click="windowClose('realNameWindowFlag2')"></i>
      <p class="realName-model-title">银行存管账户</p>
      <el-form :model="realName_form2" status-icon :rules="realName_rules2" ref="realName_form2">
        <el-form-item label="" prop="name">
          <el-input v-model.trim="realName_form2.name" v-on:input="changeCode2('realName_form2.name')"
            placeholder="请输入真实姓名" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="" prop="id">
          <el-input v-model.trim="realName_form2.id" v-on:input="changeCode2('realName_form2.id')" placeholder="请输入身份证号"
            auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="" prop="cardNo">
          <el-input v-model.trim="realName_form2.cardNo" v-on:input="changeCode2('realName_form2.cardNo')"
            placeholder="请输入银行卡号" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="" prop="entType">
          <el-select v-model="value" placeholder="请选择所属银行" @change='select'>
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="register-button button-hover" @click="submit('realName_form2')">确认</div>
      </el-form>
    </div>
    <!-- 银行交互wating model -->
    <div id="wating-model" class="model text-align-center" style="padding: 60px 0 40px 0;" v-show="watingWindowFlag">
      <p class="font-size-16 color-323232" style="margin-bottom: 25px;">请您在新网完成相应操作后，刷新当前页面</p>
      <p class="font-size-14 color-a5a5a5">如遇问题请拨打客服电话（400-8989-189）</p>
      <div class="register-button button-hover" @click="windowClose('watingWindowFlag')"
        style="width: 120px;margin: 0 auto;margin-top: 60px;">确认</div>
    </div>
    <!-- 提示 model -->
    <div id="hint-model" class="model text-align-center" style="padding: 60px 0 40px 0;" v-show="hintWindowFlag">
      <i class="iconfont icon-close model-close-button" v-on:click="windowClose('hintWindowFlag')"></i>
      <p class="font-size-16 color-323232" style="margin-bottom: 25px;">
        {{ bindingState === 0 ? '请先激活新网银行存管！': '请先完成实名认证！' }}</p>
      <div class="register-button button-hover" @click="windowClose('hintWindowFlag', true)"
        style="width: 120px;margin: 0 auto;margin-top: 60px;">{{ bindingState === 0 ? '立即激活': '确认' }}</div>
    </div>
    <!-- 解绑提示  model -->
    <div id="hint-model" class="model text-align-center" style="padding: 60px 0 40px 0;" v-show="unbundleWindowFlag">
      <p class="font-size-16 color-323232" style="margin-bottom: 10px;">如需修改或取消已绑定银行卡，请联系客服，</p>
      <p class="font-size-16 color-323232" style="margin-bottom: 10px;">客服热线：400-8989-189</p>
      <p class="font-size-16 color-323232" style="margin-bottom: 25px;">服务时间：9:00-18:00 (工作日)</p>
      <div class="register-button button-hover" @click="windowClose('unbundleWindowFlag')"
        style="width: 120px;margin: 0 auto;margin-top: 60px;">确认</div>
    </div>
    <!--风险评测model-->
    <div id="riskLevel-model" class="model" v-show="riskLevelWindowFlag">
      <i class="iconfont icon-close model-close-button" v-on:click="windowClose('riskLevelWindowFlag')"></i>
      <p class="realName-model-title">出借者风险承受能力评估问卷</p>
      <div class="topic-index font-DINBold">
        <span>{{ riskLevel_form_index + 1}}</span>/{{ riskLevelData.length }}
      </div>
      <ul class="riskLevel-ul">
        <li v-show="riskLevel_form_index === $index" v-for="(item, $index) in riskLevelData" v-bind:key="$index">
          <p class="riskLevel-model-topic">{{ item.topic }}</p>
          <el-radio-group v-model="item.value">
            <el-radio @click.native="groupChange($event)" :label="conversion($index)"
              v-for="(option, $index) in item.options" v-bind:key="$index">{{ option }}</el-radio>
          </el-radio-group>
        </li>
      </ul>
      <div class="prew-topic" v-on:click=" riskLevel_form_index -- " v-show="riskLevel_form_index"><i
          class="iconfont icon-left-line color-5e5e5e cursor-pointer"></i></div>
      <div class="register-button button-hover" v-on:click="submitRiskLevel()"
        v-show="riskLevel_form_index === riskLevelData.length - 1 && riskLevelData[riskLevelData.length - 1].value ">提交
      </div>
    </div>
    <!-- 绑定银行卡model -->
    <div id="bindBank-model" class="model" v-show="bindBankWindowFlag">
      <i class="iconfont icon-close model-close-button" v-on:click="windowClose('bindBankWindowFlag')"></i>
      <p class="realName-model-title">绑定银行卡</p>
      <el-form :model="bindBank_form" status-icon :rules="bindBank_rules" ref="bindBank_form">
        <el-form-item label="" prop="cardNo">
          <el-input v-model.trim="bindBank_form.cardNo" placeholder="请输入银行卡号" auto-complete="off"></el-input>
        </el-form-item>
        <div class="register-button button-hover" @click="submit('bindBank_form')">确认</div>
      </el-form>
    </div>
    <!--企业绑定银行卡-->
    <div id="bindBank-model" class="model" v-show="bindBankWindowFlag2">
      <i class="iconfont icon-close model-close-button" v-on:click="windowClose('bindBankWindowFlag2')"></i>
      <p class="realName-model-title">绑定银行卡</p>
      <el-form :model="bindBank_form2" status-icon :rules="bindBank_rules2" ref="bindBank_form2">
        <el-form-item label="" prop="cardNo">
          <el-input v-model.trim="bindBank_form2.cardNo" placeholder="请输入银行卡号" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="" prop="entType">
          <el-select v-model="value2" placeholder="请选择所属银行" @change='select2'>
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="register-button button-hover" @click="submit('bindBank_form2')">确认</div>
      </el-form>
    </div>
    <!-- 修改预留手机号model -->
    <div id="phone-model" class="model" v-show="phoneWindowFlag">
      <i class="iconfont icon-close model-close-button" v-on:click="windowClose('phoneWindowFlag')"></i>
      <p class="realName-model-title">修改交易手机号</p>
      <el-form :model="phone_form" status-icon :rules="phone_rules" ref="phone_form">
        <el-form-item label="" prop="phone">
          <el-input v-model.trim="phone_form.phone" v-on:input="changeCode('phone_form.phone')" placeholder="请输入新预留手机号"
            auto-complete="off"></el-input>
        </el-form-item>
        <div class="register-button button-hover" @click="submit('phone_form')">确认</div>
      </el-form>
    </div>
  </div>
</template>

<script>
  import Bus from '@/assets/js/bus.js'
  export default {
    data() {
      var checkName = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入真实姓名！'))
        } else {
          const reg = this.regex.name
          if (reg.test(value)) {
            callback()
          } else {
            callback(new Error('您输入的真实姓名有误！'))
          }
        }
      }
      var checkId = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入身份证号！'))
        } else {
          const reg = this.identityCardRegx(value)
          if (reg) {
            callback()
          } else {
            callback(new Error('您输入的身份证号有误！'))
          }
        }
      }
      var checkCard = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入银行卡号！'))
        } else {
          const reg = this.regex.bankCard
          if (reg) {
            callback()
          } else {
            callback(new Error('您输入的银行卡号有误！'))
          }
        }
      }
      var checkPhone = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入手机号！'))
        } else {
          const reg = this.regex.phone
          if (reg.test(value)) {
            callback()
          } else {
            callback(new Error('您输入的手机号有误！'))
          }
        }
      }
      return {
        inviteUrl: '普惠理财/13366401831 北京市石景山区苹果园路28号院前海人寿大厦B座13层',
        bindBankWindowFlag2: false,
        realNameWindowFlag2: false,
        exampleFlag: false,
        bindingState: null,
        riskLevelCode: null,
        fileData: {},
        isLogin: false,
        realNameWindowFlag: false,
        watingWindowFlag: false,
        riskLevelWindowFlag: false,
        bindBankWindowFlag: false,
        hintWindowFlag: false,
        phoneWindowFlag: false,
        unbundleWindowFlag: false,
        userInfo: {
          activeMsg: null,
          bankInfo: {
            bankName: null,
            bankNo: null,
            id: null,
            yeepayMobile: null
          },
          bankMsg: null,
          custUserInfo: {
            custType: null,
            email: null,
            id: null,
            mobile: null,
            resetUserNameFlag: null,
            riskLevel: null,
            userName: null
          },
          emailInfo: {
            email: null,
            id: null
          },
          headPhoto: null,
          msgConfigInfo: null,
          realNameInfo: {
            id: null,
            idCard: null,
            realName: null
          }
        },
        realName_form2: {
          name: null,
          id: null,
          cardNo: null,
          bankcode: null
        },
        realName_rules2: {
          name: [{
            validator: checkName,
            trigger: 'blur'
          }],
          id: [{
            validator: checkId,
            trigger: 'blur'
          }],
          cardNo: [{
            validator: checkCard,
            trigger: 'blur'
          }]
        },
        realName_form: {
          name: null,
          id: null
        },
        realName_rules: {
          name: [{
            validator: checkName,
            trigger: 'blur'
          }],
          id: [{
            validator: checkId,
            trigger: 'blur'
          }]
        },
        bindBank_form2: {
          cardNo: null,
          bankcode: null
        },
        bindBank_rules2: {
          cardNo: [{
            validator: checkCard,
            trigger: 'blur'
          }]
        },
        bindBank_rules: {
          cardNo: [{
            validator: checkCard,
            trigger: 'blur'
          }]
        },
        bindBank_form: {
          cardNo: null
        },
        phone_rules: {
          phone: [{
            validator: checkPhone,
            trigger: 'blur'
          }]
        },
        phone_form: {
          phone: null
        },
        riskLevel_form: {
          radio_1: null,
          radio_2: null,
          radio_3: null,
          radio_4: null,
          radio_5: null,
          radio_6: null,
          radio_7: null,
          radio_8: null,
          radio_9: null,
          radio_10: null
        },
        enterFlagbank: true,
        enterFlag: false,
        gorealNameTip: '',
        riskLevel_form_index: 0,
        options: [],
        value: '',
        options2: [],
        value2: '',
        gorealName: '立即实名',
        gorealNameClassFlag: false,
        riskLevelData: [{
          topic: '您的家庭年收入为多少（人民币）？',
          options: ['5万元以下', '5-20万元', '20-50万元', '50-100万元', '100万元以上'],
          value: null
        }, {
          topic: '在您每年的家庭收入中，可用于出借理财的比例为？',
          options: ['10%以下', '10%-25%', '25%-50%', '50%以上'],
          value: null
        }, {
          topic: '您目前的出借理财产品主要有那些？',
          options: ['存款（银行、宝宝类）', '债券、偏债型基金', '股票、偏股型基金', '金融衍生品（如期货、外汇等）、私募股权出借'],
          value: null
        }, {
          topic: '以下哪项描述最符合您的出借态度？',
          options: ['厌恶风险，不希望本金损失，希望获得稳定回报', '保守出借，不希望本金损失，愿意承担一定幅度的回报波动', '寻求资金的较高回报和成长性，愿意为此承担有限本金损失',
            '希望赚取高回报，愿意为此承担较大本金损失'
          ],
          value: null
        }, {
          topic: '您喜欢并能接受的出借期限是多久？',
          options: ['90天以下', '90-180天', '180-360天', '360天以上'],
          value: null
        }, {
          topic: '您的出借目的是？',
          options: ['资产保值', '资产稳健增长', '资产迅速增长'],
          value: null
        }, {
          topic: '您的出借出现何种程度的波动时，您会呈现明显的焦虑？',
          options: ['本金无损失，但回报未达预期', '出现轻微本金损失', '本金10%以内的损失', '本金10%-20%的损失', '本金20%以上的损失'],
          value: null
        }]
      }
    },
    computed: {
      custType3() {
        return this.$store.state.custType3
      },
      custType4() {
        return this.$store.state.custType4
      }
    },
    mounted() {
      this.verifyLogin().then((res) => {
        this.$_init()
      }).catch(() => {
        this.$router.replace({
          path: '/index.htm',
          query: {
            status: 'noLogin'
          }
        })
      })
      Bus.$on('bindBankWindow', content => {
        if (this.enterFlag) {
          // 企业
          this.windowOpen('bindBankWindowFlag2', true)
        } else {
          this.windowOpen('bindBankWindowFlag', true)
        }
      })
      Bus.$on('hintWindow', content => {
        // 打开激活
        this.windowOpen('hintWindowFlag', true)
      })
      if (this.$route.params.mineTipData === 'nobank') {
        if (this.enterFlag) {
          // 企业
          this.windowOpen('bindBankWindowFlag2', true)
        } else {
          this.windowOpen('bindBankWindowFlag', true)
        }
      } else if (this.$route.params.mineTipData === 'riskLevel') {
        this.windowOpen('riskLevelWindowFlag', true)
      }
    },
    methods: {
      onCopy(e) {
        this.$message.success('复制成功！')
      },
      // 复制失败
      onError(e) {
        this.$message.error('复制失败！')
      },
      // 下载示例
      loadBook() {
        if (typeof window !== 'undefined') {
          window.location.href = 'https://www.puhuilicai.com/apis/web-server/commonFiles/doc/普惠理财实名认证申请书.docx'
        }
      },
      $_init() {
        this.custUserInfo()
        this.getFileData()
        this.getUserInfoForIndex()
        this.getEntRegisterBank()
      },
      select(value) {
        this.realName_form2.bankcode = value
      },
      select2(value) {
        this.bindBank_form2.bankcode = value
      },
      realNameenterOrpeo() {
        if (!this.gorealNameClassFlag) {
          if (this.enterFlag) {
            // 企业
            this.windowOpen('realNameWindowFlag2', !this.userInfo.realNameInfo.id)
          } else {
            this.windowOpen('realNameWindowFlag', !this.userInfo.realNameInfo.id)
          }
        }
      },
      bankenterOrpeo() {
        if (this.enterFlag) {
          // 企业
          this.windowOpen('bindBankWindowFlag2', true)
        } else {
          this.windowOpen('bindBankWindowFlag', true)
        }
      },
      getEntRegisterBank() {
        this.axios({
          url: this.HOST + '/web-server/bank/v2/web/getEntRegisterBank',
          method: 'POST',
          data: {},
          transformRequest: [function(data, headers) {}],
          transformResponse: [function(data, headers) {
            return JSON.parse(data)
          }]
        }).then((res) => {
          if (res.data.code === 1) {
            res.data.data.bankData.forEach(function(value, i) {
              value.value = value.code
              value.label = value.flag
            })
            this.options = res.data.data.bankData
          } else {
            this.$message({
              message: '请重试!',
              type: 'warning'
            })
          }
        })
      },
      modifyinformation() {
        if (this.userInfo.realNameInfo.id) {
          this.axios({
            url: this.HOST + '/web-server/registerRequest/v2/web/setEnterpriseInfoUpdate',
            method: 'POST',
            data: {},
            transformRequest: [function(data, headers) {}],
            transformResponse: [function(data, headers) {
              return JSON.parse(data)
            }]
          }).then((res) => {
            if (res.data.code === 1) {
              this.bankYeepay(res.data.data)
              this.windowOpen('watingWindowFlag', true)
            } else {
              this.$message({
                message: '请重试!',
                type: 'warning'
              })
            }
          })
        } else {
          this.windowOpen('hintWindowFlag', true)
        }
      },
      getUserInfoForIndex() {
        this.axios({
          url: this.HOST + '/web-server/index/v2/web/getUserInfoForIndex',
          method: 'GET',
          data: {},
          transformRequest: [function(data, headers) {}],
          transformResponse: [function(data, headers) {
            return JSON.parse(data)
          }]
        }).then((res) => {
          if (res.data.code === 1) {
            if (res.data.data.custUserInfo.custType === 1) {
              // 企业
              this.enterFlag = true
              this.enterFlagbank = false
              this.$store.commit('updatecustType3', false)
              this.$store.commit('updatecustType4', true)
            } else {
              this.enterFlag = false
              this.enterFlagbank = true
              this.$store.commit('updatecustType3', true)
              this.$store.commit('updatecustType4', false)
            }
          }
        })
      },
      windowOpen(flag, bool) {
        if (bool) {
          this.$refs.bindBank_form.resetFields()
          this.$refs.realName_form.resetFields()
          this.$refs.realName_form2.resetFields()
          this.$mask.hide()
          this.$mask.show()
          this[flag] = true
        } else {
          return false
        }
      },
      windowClose(flag, s) {
        if (flag === 'hintWindowFlag' && !this.bindingState && s) {
          this.upgrade()
        } else if (flag === 'hintWindowFlag' && this.bindingState === 1) {
          this[flag] = false
          if (this.enterFlag) {
            // 企业
            this.windowOpen('realNameWindowFlag2', !this.userInfo.realNameInfo.id)
          } else {
            this.windowOpen('realNameWindowFlag', !this.userInfo.realNameInfo.id)
          }
        } else {
          this[flag] = false
          this.$mask.hide()
          if (flag === 'watingWindowFlag') {
            this.reload()
          }
        }
      },
      getFileData() {
        this.axios({
          url: this.HOST + '/web-server/account/v1/getloadContractFb',
          method: 'GET',
          params: {},
          data: {}
        }).then((res) => {
          if (res.data.data.code === '1' || res.data.data.code === '1111') {
            this.fileData = res.data.data
          }
        })
      },
      openFile(type) {
        if (this.isLogin) {
          if (this.userInfo.realNameInfo.id) {
            window.open(this.imgHost + (type === 4 ? this.fileData.loanContract : this.fileData.riskContract))
          } else {
            this.$router.push({
              path: type === 4 ? '/companyMessage/privacyClause.htm' : '/companyMessage/riskHints.htm'
            })
          }
        } else {
          this.$router.replace({
            path: '/index.htm',
            query: {
              status: 'noLogin'
            }
          })
        }
      },
      custUserInfo() {
        this.axios({
          url: this.HOST + '/web-server/account/v2/getRiskAssessment',
          method: 'GET',
          params: {},
          data: {}
        }).then((res) => {
          if (res.data.data.code === '1') {
            this.riskLevelCode = true
          } else {
            this.riskLevelCode = false
          }
        })
        this.axios({
          url: this.HOST + '/web-server/account/v1/custUserInfo',
          method: 'GET',
          params: {},
          data: {}
        }).then((res) => {
          if (res.data.data.code === 1) {
            this.isLogin = true
            this.userInfo = res.data.data
            if (res.data.data.activeMsg === 'ENT_AUDIT') {
              // 审核中
              this.gorealName = '审核中'
              this.gorealNameTip = '审核中'
              this.gorealNameClassFlag = true
            } else {
              this.gorealName = '立即实名'
              this.gorealNameClassFlag = false
              if (res.data.data.realNameInfo.id) {
                this.gorealNameClassFlag = true
                this.gorealNameTip = res.data.data.realNameInfo.realName
              }
            }
            if (res.data.data.activeMsg === 'AUTH_ACTIVE_USER') {
              this.bindingState = 0
              this.windowOpen('hintWindowFlag', true)
            } else if (res.data.data.activeMsg === 'AUTH_BANK') {
              this.bindingState = 1
              this.windowOpen('hintWindowFlag', true)
            } else {
              this.bindingState = 1
              if (this.$route.query.flag) {
                if (this.$route.query.flag === 'bindBankWindowFlag' && !this.userInfo.realNameInfo.id) {
                  this.windowOpen('hintWindowFlag', true)
                } else {
                  this.windowOpen(this.$route.query.flag, true)
                }
              }
            }
          } else if (res.data.data.code === 1111) {
            this.$router.replace({
              path: '/index.htm',
              query: {
                status: 'noLogin'
              }
            })
            this.isLogin = false
            this.userInfo = {
              activeMsg: null,
              bankInfo: {
                bankName: null,
                bankNo: null,
                id: null
              },
              bankMsg: null,
              custUserInfo: {
                custType: null,
                email: null,
                id: null,
                mobile: null,
                resetUserNameFlag: null,
                riskLevel: null,
                userName: null
              },
              emailInfo: {
                email: null,
                id: null
              },
              headPhoto: null,
              msgConfigInfo: null,
              realNameInfo: {
                id: null,
                idCard: null,
                realName: null
              }
            }
          }
        })
      },
      submit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (formName === 'realName_form') {
              /* 实名认证 */
              this.axios({
                url: this.HOST + '/web-server/registerRequest/v1/register',
                method: 'POST',
                params: {},
                data: {
                  realName: this.realName_form.name,
                  cardNo: this.realName_form.id
                },
                transformRequest: [(data, headers) => {
                  return this.$qs.stringify(data)
                }],
                transformResponse: [(data, headers) => {
                  return JSON.parse(data)
                }]
              }).then((res) => {
                if (res.data.data.code === '1') {
                  this.bankYeepay(res.data.data)
                  this.realNameWindowFlag = false
                  this.watingWindowFlag = true
                } else if (res.data.data.code === '100002') {
                  this.$message.error('该用户已认证！')
                } else if (res.data.data.code === '100006') {
                  this.$message.error('您暂未完成风险测评！')
                } else {
                  this.$message.error(res.data.data.msg)
                }
              })
            } else if (formName === 'realName_form2') {
              /* 实名认证 */
              this.axios({
                url: this.HOST + '/web-server/registerRequest/v1/register',
                method: 'POST',
                params: {},
                data: {
                  realName: this.realName_form2.name,
                  cardNo: this.realName_form2.id,
                  bankcardNo: this.realName_form2.cardNo,
                  bankcode: this.realName_form2.bankcode
                },
                transformRequest: [(data, headers) => {
                  return this.$qs.stringify(data)
                }],
                transformResponse: [(data, headers) => {
                  return JSON.parse(data)
                }]
              }).then((res) => {
                if (res.data.data.code === '1') {
                  this.bankYeepay(res.data.data)
                  this.realNameWindowFlag2 = false
                  this.watingWindowFlag = true
                } else if (res.data.data.code === '100002') {
                  this.$message.error('该用户已认证！')
                } else if (res.data.data.code === '100006') {
                  this.$message.error('您暂未完成风险测评！')
                } else {
                  this.$message.error(res.data.data.msg)
                }
              })
            } else if (formName === 'bindBank_form') {
              /* 绑定银行卡 */
              this.axios({
                url: this.HOST + '/web-server/v1/payment/toBindBank',
                method: 'post',
                transformRequest: [(data, headers) => {
                  return this.$qs.stringify(data)
                }],
                params: {},
                data: {
                  bankNo: this.bindBank_form.cardNo
                },
                timeout: 5000,
                transformResponse: [(data, headers) => {
                  return JSON.parse(data)
                }]
              }).then((res) => {
                if (res.data.data.code === '1') {
                  this.bankYeepay(res.data.data)
                  this.bindBankWindowFlag = false
                  this.watingWindowFlag = true
                } else if (res.data.data.code === '100002') {
                  this.windowClose('bindBankWindowFlag')
                  this.reload()
                  this.$message.error('用户已绑卡！')
                } else if (res.data.data.code === '100001') {
                  this.$message.error('验证码已失效！')
                } else {
                  this.$message.error(res.data.data.msg)
                }
              })
            } else if (formName === 'bindBank_form2') {
              /* 绑定银行卡 */
              this.axios({
                url: this.HOST + '/web-server/v1/payment/toBindBank',
                method: 'post',
                transformRequest: [(data, headers) => {
                  return this.$qs.stringify(data)
                }],
                params: {},
                data: {
                  bankNo: this.bindBank_form2.cardNo,
                  bankCode: this.bindBank_form2.bankcode
                },
                timeout: 5000,
                transformResponse: [(data, headers) => {
                  return JSON.parse(data)
                }]
              }).then((res) => {
                if (res.data.data.code === '1') {
                  this.bankYeepay(res.data.data)
                  this.bindBankWindowFlag2 = false
                  this.watingWindowFlag = true
                } else if (res.data.data.code === '100002') {
                  this.windowClose('bindBankWindowFlag')
                  this.reload()
                  this.$message.error('用户已绑卡！')
                } else if (res.data.data.code === '100001') {
                  this.$message.error('验证码已失效！')
                } else {
                  this.$message.error(res.data.data.msg)
                }
              })
            } else if (formName === 'phone_form') {
              /* 修改预留手机号 */
              this.axios({
                url: this.HOST + '/web-server/account/v2/web/resetMobile',
                method: 'post',
                transformRequest: [(data, headers) => {
                  return this.$qs.stringify(data)
                }],
                params: {},
                data: {
                  mobile: this.phone_form.phone,
                  appModel: 'pc'
                },
                timeout: 5000,
                transformResponse: [(data, headers) => {
                  return JSON.parse(data)
                }]
              }).then((res) => {
                if (res.data.code === 1) {
                  res.data.data.cgtData = res.data.data
                  res.data.data.requestNo = JSON.parse(res.data.data.reqData).requestNo
                  this.bankYeepay(res.data.data)
                  this.phoneWindowFlag = false
                  this.watingWindowFlag = true
                } else {
                  this.windowClose('phoneWindowFlag')
                  this.$message.error(res.data.data.msg)
                }
              })
            }
          } else {
            return false
          }
        })
      },
      conversion(index) {
        switch (index) {
          case 0:
            return '2'
          case 1:
            return '6'
          case 2:
            return '9'
          case 3:
            return '12'
          case 4:
            return '20'
        }
      },
      groupChange($event) {
        if ($event.target.nodeName === 'INPUT') {
          this.riskLevel_form_index = this.riskLevel_form_index + 1 < this.riskLevelData.length ? this
            .riskLevel_form_index + 1 : this.riskLevel_form_index
        }
      },
      /* 风险评测 */
      submitRiskLevel() {
        this.axios({
          url: this.HOST + '/web-server/account/v1/saveBidQuestion',
          method: 'post',
          params: {},
          data: {
            income: this.riskLevelData[0].value,
            investRatio: this.riskLevelData[1].value,
            investTerm: this.riskLevelData[2].value,
            investAttitude: this.riskLevelData[3].value,
            investExp: this.riskLevelData[4].value,
            factorMode: this.riskLevelData[5].value,
            investWave: this.riskLevelData[6].value
          },
          timeout: 5000,
          transformRequest: [(data, headers) => {
            return this.$qs.stringify(data)
          }],
          transformResponse: [(data, headers) => {
            return JSON.parse(data)
          }]
        }).then((res) => {
          if (res.data.data.code === 1) {
            this.reload()
            this.windowClose('riskLevelWindowFlag')
            this.riskLevel_form_index = 0
            for (let i in this.riskLevelData) {
              this.riskLevelData[i].value = null
            }
            this.reload()
          } else {
            this.$message.error(res.data.data.msg)
          }
        })
      },
      /* 绑定银行 */
      bindBank() {
        if (this.userInfo.realNameInfo.id && this.bindingState) {
          if (this.userInfo.bankInfo.id) {
            /* 解绑 */
            this.axios({
              url: this.HOST + '/web-server/v1/payment/toUnbindBank',
              method: 'post',
              params: {},
              data: {},
              timeout: 5000
            }).then((res) => {
              if (res.data.data.code === '1') {
                this.$confirm('您确定解绑该银行卡？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  this.bankYeepay(res.data.data)
                  this.windowOpen('watingWindowFlag', true)
                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消操作'
                  })
                })
              } else if (res.data.data.code === '1111') {
                this.$message.error('用户未登录!')
              } else if (res.data.data.code === '100003') {
                this.windowOpen('unbundleWindowFlag', true)
              } else if (res.data.data.code === '100004') {
                this.$message.error('用户未绑卡!')
                this.reload()
              } else if (res.data.data.code === '100005') {
                this.windowOpen('unbundleWindowFlag', true)
              } else {
                this.$message.error(res.data.data.msg)
              }
            })
          } else {
            /* 绑定 */
            this.bankenterOrpeo()
          }
        } else {
          this.windowOpen('hintWindowFlag', true)
        }
      },
      resetPassword() {
        if (this.userInfo.realNameInfo.id && this.bindingState) {
          this.$confirm('您确定修改交易密码？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            lockScroll: false
          }).then(() => {
            this.axios({
              url: this.HOST + '/web-server/account/v1/toYeePayResetPassword',
              method: 'POST',
              params: {},
              data: {},
              transformRequest: [(data, headers) => {
                return this.$qs.stringify(data)
              }],
              transformResponse: [(data, headers) => {
                return JSON.parse(data)
              }]
            }).then((res) => {
              if (res.data.data.isEnterprise === 'yes') {
                this.windowOpen('watingWindowFlag', true)
                res.data.data.cgtData = res.data.data
                res.data.data.requestNo = JSON.parse(res.data.data.reqData).requestNo
                this.bankYeepay(res.data.data)
              } else {
                this.$message.error(res.data.data.msg)
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            })
          })
        } else {
          this.windowOpen('hintWindowFlag', true)
        }
      },
      resetPhone() {
        if (this.userInfo.realNameInfo.id && this.userInfo.bankInfo.id && this.bindingState) {
          this.windowOpen('phoneWindowFlag', true)
        } else {
          if (this.userInfo.realNameInfo.id) {
            this.$message.error('请您先绑定银行卡！')
          } else {
            this.windowOpen('hintWindowFlag', true)
          }
        }
      },
      changeCode(field) {
        if (field === 'phone_form.phone') {
          this.phone_form.phone = this.phone_form.phone.replace(/\D/gi, '')
        } else if (field === 'realName_form.name') {
          let arr = this.realName_form.name.toString().split('')
          let num = 0
          for (let i = 0; i < arr.length; i++) {
            arr[i] = arr[i] === '·' ? arr[i] : arr[i].replace(/[^\u4e00-\u9fa5|,]+/, '')
            arr[i] = arr[i] === '·' && i === 0 ? '' : arr[i]
            if (arr[i] === '·') {
              num++
              if (num > 1) {
                arr[i] = ''
              }
            }
          }
          this.realName_form.name = arr.join('')
        } else if (field === 'realName_form.id') {
          this.realName_form.id = this.realName_form.id.toString()
          if (this.realName_form.id.length < 18) {
            this.realName_form.id = this.realName_form.id.replace(/\D/gi, '')
          } else if (this.realName_form.id.length === 18) {
            this.realName_form.id = this.realName_form.id[17] === 'X' ? this.realName_form.id : this.realName_form.id
              .replace(/\D/gi, '')
          } else {
            this.realName_form.id = this.realName_form.id.slice(0, 18)
          }
        }
      },
      changeCode2(field) {
        if (field === 'phone_form.phone') {
          this.phone_form.phone = this.phone_form.phone.replace(/\D/gi, '')
        } else if (field === 'realName_form2.name') {
          let arr = this.realName_form2.name.toString().split('')
          let num = 0
          for (let i = 0; i < arr.length; i++) {
            arr[i] = arr[i] === '·' ? arr[i] : arr[i].replace(/[^\u4e00-\u9fa5|,]+/, '')
            arr[i] = arr[i] === '·' && i === 0 ? '' : arr[i]
            if (arr[i] === '·') {
              num++
              if (num > 1) {
                arr[i] = ''
              }
            }
          }
          this.realName_form2.name = arr.join('')
        } else if (field === 'realName_form2.id') {
          this.realName_form2.id = this.realName_form2.id.toString()
          if (this.realName_form2.id.length < 18) {
            this.realName_form2.id = this.realName_form2.id.replace(/\D/gi, '')
          } else if (this.realName_form2.id.length === 18) {
            this.realName_form2.id = this.realName_form2.id[17] === 'X' ? this.realName_form2.id : this.realName_form2
              .id.replace(/\D/gi, '')
          } else {
            this.realName_form2.id = this.realName_form2.id.slice(0, 18)
          }
        }
      },
      upgrade() {
        this.axios({
          url: this.HOST + '/web-server/registerRequest/v1/activePlatuser',
          method: 'POST',
          params: {},
          data: {}
        }).then((res) => {
          if (res.data.data.code === '1') {
            res.data.data.cgtData = res.data.data.cgtData
            res.data.data.requestNo = JSON.parse(res.data.data.cgtData.reqData).requestNo
            this.bankYeepay(res.data.data)
            this.hintWindowFlag = false
            this.watingWindowFlag = true
          } else {
            this.$message.error(res.data.data.msg)
          }
        })
      }
    }
  }
</script>

<style lang="less">
  #example-model {
    width: 670px !important;
    height: 450px;
    padding: 26px;
    padding-right: 0;
    box-sizing: border-box;

    .example-title {
      font-size: 14px;
      color: #323232;
      padding-top: -26px;
      font-weight: 700;
    }

    .example-content {
      padding-top: 30px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;

      .content-box {
        flex: 0 0 188px;

        .title {
          font-size: 12px;
          color: #323232;
          line-height: 20px;
          font-weight: bold;
        }

        .text {
          line-height: 17px;
          font-size: 12px;
          color: #707070;
          padding-left: 20px;
          margin-bottom: 18px;
        }

        .btn {
          margin-top: 30px;
          width: 120px;
          height: 36px;
          line-height: 36px;
          text-align: center;
          font-size: 16px;
          margin-left: 20px;
          border: 1px solid #e6382c;
          border-radius: 3px;
          color: #e6382c;
          cursor: pointer;
        }

        .btn.bottom {
          margin-top: 120px;
        }
      }
    }
  }
  #bankDepository-view {
    .paper-box {
      width: 930px;
      height: 100px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 3px 6px 0px rgba(102, 102, 102, 0.14);
      border-radius: 4px;
      margin-bottom: 45px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .paper-text-box {
        padding: 5px 30px;
        box-sizing: border-box;

        .title {
          font-size: 14px;
          color: #a5a5a5;
          line-height: 30px;
          padding-left: 20px;
          background: url(../../assets/images/exclame.png) no-repeat 0 7px;
        }

        .text {
          font-size: 14px;
          color: #323232;
          line-height: 25px;
        }
      }
      .paper-boxC{
        width: 1px;
        height: 45px;
        background: #eee;
        margin-top: 25px;
      }
      .paper-btn-box {
        box-sizing: border-box;
        padding-right: 60px;
        padding-top: 30px;
        height: 50px;
        display: flex;
        height: 100%;

        .btn {
          width: 120px;
          height: 36px;
          line-height: 36px;
          text-align: center;
          font-size: 16px;
          border: 1px solid #e6382c;
          border-radius: 3px;
          color: #e6382c;
          cursor: pointer;
        }

        .btn:first-child {
          margin-right: 10px;
        }

        .btn.red {
          color: #fff;
          background: linear-gradient(135deg, #fe5622 0%, #f6463e 100%);
        }
      }
    }

    width: 1010px;
    background: #fff;
    padding: 0 40px;

    .el-select {
      width: 100%;
    }

    .bankDepository-section {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding-top: 4px;

      li {
        width: 218px;
        height: 270px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 3px 6px 0px rgba(102, 102, 102, 0.14);
        border-radius: 4px;
        margin-bottom: 45px;
        text-align: center;
        margin: 0 0 40px 0;
        position: relative;
        padding-top: 40px;
        box-sizing: border-box;

        img {
          margin: 0 auto;
        }

        .label {
          width: 25px;
          height: 55px;
          position: absolute;
          left: 20px;
          top: -5px;
          text-align: center;
          letter-spacing: 2px;
          line-height: 14px;
          padding-top: 3px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          background: url(../../assets/images/backDepositiory_label_2.png) no-repeat;

          &.label-accomplish {
            background: url(../../assets/images/backDepositiory_label_1.png) no-repeat;
          }
        }

        .detail {
          font-size: 14px;
          color: #5e5e5e;
          position: relative;
          top: 20px;
        }

        .type {
          height: 16px;
          font-size: 16px;
          font-weight: 400;
          color: rgba(50, 50, 50, 1);
          line-height: 20px;
          margin-top: 7px;
        }

        div {
          width: 120px;
          height: 36px;
          background: linear-gradient(135deg, rgba(254, 86, 34, 1) 0%, rgba(246, 70, 62, 1) 100%);
          box-shadow: 0px 8px 12px 0px rgba(102, 102, 102, 0.14);
          border-radius: 4px;
          margin: 0 auto;
          position: absolute;
          left: 49px;
          bottom: 33px;
          text-align: center;
          line-height: 36px;
          font-size: 16px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);

          &.accomplish {
            background: rgba(238, 238, 238, 1);
            border-radius: 4px;
            color: rgba(165, 165, 165, 1);
          }

          a {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            color: #fff;
          }
        }
      }

      &:after {
        content: "";
        display: block;
        height: 1px;
        width: 218px;
      }
    }

    .model {
      width: 470px;
      background: rgba(255, 255, 255, 1);
      border-radius: 4px;
      box-sizing: border-box;
      position: fixed;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 1000;

      .model-close-button {
        width: 15px;
        height: 15px;
        position: absolute;
        top: 12px;
        right: 12px;
        cursor: pointer;
      }

      &#realName-model,
      &#bindBank-model,
      &#phone-model {
        width: 370px;
        padding: 50px 55px;

        .realName-model-title {
          font-size: 24px;
          font-weight: 400;
          color: rgba(50, 50, 50, 1);
          line-height: 24px;
          margin-bottom: 30px;
        }
      }

      &#riskLevel-model {
        width: 500px;
        height: 390px;
        padding: 24px 25px;

        &:after {
          content: "";
          display: block;
          width: 100%;
          height: 1px;
          position: absolute;
          left: 0;
          top: 65px;
          background: #eee;
        }

        .topic-index {
          font-size: 12px;
          position: absolute;
          left: 25px;
          top: 84px;

          >span {
            font-size: 26px;
            color: #E6382C;
          }

          .radio {
            color: #323232;
          }
        }

        .riskLevel-ul {
          margin-top: 50px;

          .riskLevel-model-topic {
            padding-left: 37px;
            margin-bottom: 7px;
            font-size: 14px;
            color: #323232;
          }

          .el-radio {
            color: #323232;
            width: 100%;
            margin: 8px 0;
          }
        }

        .register-button {
          width: 120px;
          position: absolute;
          right: 30px;
          bottom: 40px;
        }

        .prew-topic {
          width: 30px;
          height: 30px;
          background: rgba(238, 238, 238, 1);
          border-radius: 50%;
          text-align: center;
          line-height: 30px;
          position: absolute;
          left: 30px;
          bottom: 43px;

          i {
            color: #5E5E5E;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/accountTotal/bankDepository.vue